import React from 'react'

export default function EditorialTeam() {
  return (
    <div>EditorialTeam</div>
  )
}
